/**
 * Simple model to use for navigation state
 *
 * Use or extend this for more sophisticated states.
 * The most basic state is 'selected'
 */
import Backbone from 'backbone';
    export default Backbone.Model.extend({ selected: false });

